export const SIDEBAR_EXPAND_EVENT = "sidebar:expand";
export const SIDEBAR_COLLAPSE_EVENT = "sidebar:collapse";

/**
 * dispatchSidebarToggleEvent
 * Fires `sidebar:expand` or `sidebar:collapse` on `window` when the user toggles the nav,
 * so code outside the SidebarLayout tree (or outside React entirely) can react to it.
 */
export function dispatchSidebarToggleEvent(expanded: boolean) {
    if (typeof window === "undefined") {
        return;
    }

    window.dispatchEvent(
        new Event(expanded ? SIDEBAR_EXPAND_EVENT : SIDEBAR_COLLAPSE_EVENT),
    );
}
